module.exports = __webpack_public_path__ + "img/tab-image-art-shopAvatar.8a639315.png";